import useMediaGetter from "@/app/hooks/useMediaGetter";
import { FinishingDataProps } from "@/app/types/types";
import Image from "next/image";
import ImageWithLoader from "../shared/imageWithLoader/ImageWithLoader";

const FinishingComponentContent = ({
	data,
	item,
	index,
	optimizedImage,
}: {
	data: FinishingDataProps[];
	item: FinishingDataProps;
	index: number;
	optimizedImage?: boolean;
}) => {
	const { imgSrc } = useMediaGetter(item?.media);

	return (
		<div
			className={`FinishingContent_list-item w-[100%] flex flex-col justify-center text-center align-center mt-[2.38rem] gap-8 ${
				index !== data.length - 1 ? "border-r-2" : ""
			}`}
			key={index}
		>
			<div className="FinishingContent_list-item_title text-[#081629] ">
				{item.title?.en}
			</div>
			<div className="image_wrapper relative w-[15rem] h-[15rem] mx-auto ">
				{imgSrc && (
					optimizedImage ? (
						<ImageWithLoader
							src={`${imgSrc}`}
							alt={item?.media[0]?.alt_text || ""}
							sizeVariant="trimCard"
							contain
							quality={75}
						/>
					) : (
						<Image src={`${imgSrc}`} alt={item?.media[0]?.alt_text || ""} fill />
					)
				)}
			</div>
			<div className="FinishingContent_list-item_desc text-h6 ">
				{item.sub_title?.en}
			</div>
		</div>
	);
};

export default FinishingComponentContent;
